import { UploadOutlined } from "@ant-design/icons";
import { Button, notification, Upload, UploadFile } from "antd";
import { UploadProps } from "antd/lib";
import React, { useEffect, useState } from "react";
import { t } from "i18next";

type PropsRCUploader = Omit<UploadProps, "onChange"> & {
  onChange?: (file: UploadFile | undefined) => void;
  value?: UploadFile;
  allowedFileTypes: Set<string>;
};

export const RCUploader: React.FC<PropsRCUploader> = ({
  onChange,
  value,
  allowedFileTypes,
  ...props
}) => {
  const [fileList, setFileList] = useState<UploadFile[]>([]);

  useEffect(() => {
    if (value) {
      setFileList([value]);
    } else {
      setFileList([]);
    }
  }, [value]);

  const uploadCpmProps: UploadProps = {
    onRemove: () => {
      setFileList([]);
      onChange?.(undefined);
    },
    beforeUpload: (file) => {
      if (!file) return false;
      if (!allowedFileTypes.has(file.type)) {
        notification.error({
          message: t("Error"),
          description: t("This file format is not supported"),
        });
        return Upload.LIST_IGNORE;
      }
      setFileList([file]);
      onChange?.(file);
      return false;
    },
    fileList,
  };

  return (
    <Upload
      {...props}
      {...uploadCpmProps}
      showUploadList={fileList.length > 0 ? { showRemoveIcon: true } : false}
    >
      <Button size="small" icon={<UploadOutlined />}>
        {t("Upload a file")}
      </Button>
    </Upload>
  );
};
